import React from 'react';
import "../../css/slider.css";

const mainLandMark = (props) => (
    <div className="slider-container1">
    </div>
    );

export default mainLandMark;